"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.websocketService = exports.WebsocketService = void 0;
var helpers_1 = require("./helpers");
var messages_1 = require("../constants/messages");
var index_1 = require("../index");
var WebsocketService = /** @class */ (function () {
    function WebsocketService() {
        var _this = this;
        /** A map of requested subscription names and the callback for them */
        this.sockets = new Map();
        /** Indicator if the websocket is already connected */
        this.isConnected = false;
        /** Global promise object that resolves when init completes */
        this.initPromise = (0, helpers_1.generatePromiseObjects)();
        /**
         * This function handles when a connection is opened
         */
        this.handleOpen = function () {
            if (_this.isConnected || !_this.joinChannel()) {
                return;
            }
            _this.isConnected = true;
            _this.updateRpcPort();
            _this.notifyEvent('RECONNECT');
        };
        /**
         * This function handles completed subscription
         */
        this.handleClose = function () {
            if (_this.isConnected) {
                _this.isConnected = false;
                _this.notifyEvent('CLOSED');
            }
            if (!_this.globalSocket) {
                _this.handleNotReady();
                return;
            }
            _this.reconnect();
        };
        /**
         * This function handles errors received from the websocket
         */
        this.handleError = function () {
            (0, helpers_1.errorLog)(messages_1.messages.websocketClosedError);
        };
        /**
         * This function handles messages received from the websocket
         */
        this.handleMessage = function (message) {
            var data;
            try {
                data = JSON.parse(message.data);
            }
            catch (error) {
                (0, helpers_1.errorLog)('Unable to parse Websocket message', { error: error, message: message });
            }
            // Message we get on subscription
            if (data && data.id === 1) {
                _this.initPromise.resolver(data);
                return;
            }
            var socket = _this.sockets.get(data.method);
            if (socket && data.params) {
                socket(data.params);
            }
        };
    }
    /** Log call for not being ready */
    WebsocketService.prototype.handleNotReady = function () {
        (0, helpers_1.errorLog)(messages_1.messages.websocketNotReady);
    };
    /**
     * This function joins the channel to be able to subscribe to events
     */
    WebsocketService.prototype.joinChannel = function () {
        if (!this.globalSocket) {
            this.handleNotReady();
            return false;
        }
        this.globalSocket.send(JSON.stringify({ jsonrpc: '2.0', method: 'subscribe_transfer_activity', params: [index_1.asperaSdk.globals.appId], id: 1 }));
        return true;
    };
    /**
     * This function registers clients to listen to a certain message name. Returns any to allow functions to declare proper type
     *
     * @param messageName - the name of messages to listen to (one message name per subscription)
     * @param callback - the callback function
     */
    WebsocketService.prototype.registerMessage = function (messageName, callback) {
        if (!this.sockets.get(messageName)) {
            this.sockets.set(messageName, function (data) {
                callback(data.result);
            });
        }
    };
    /**
     *
     * @param callback This function registers clients to a certain WebSocket event.
     *
     * @param callback - the callback function to call with the event name.
     */
    WebsocketService.prototype.registerEvent = function (callback) {
        this.eventListener = callback;
        this.eventListener(this.isConnected ? 'RECONNECT' : 'CLOSED');
    };
    /**
     * This function starts the websocket subscription with the websocket provider
     *
     * @returns a promise that resolves when the websocket connection is established
     */
    WebsocketService.prototype.init = function () {
        this.connect();
        return this.initPromise.promise;
    };
    WebsocketService.prototype.connect = function () {
        var _this = this;
        this.getWebSocketConnection(33024, 33029)
            .then(function (webSocket) {
            _this.globalSocket = webSocket;
            _this.globalSocket.onerror = _this.handleError;
            _this.globalSocket.onclose = _this.handleClose;
            _this.globalSocket.onopen = _this.handleOpen;
            _this.globalSocket.onmessage = _this.handleMessage;
            _this.handleOpen();
        }).catch(function () {
            _this.reconnect();
        });
    };
    WebsocketService.prototype.reconnect = function () {
        var _this = this;
        if (this.globalSocket) {
            this.globalSocket.close();
        }
        setTimeout(function () {
            _this.connect();
        }, 1000);
    };
    WebsocketService.prototype.getWebSocketConnection = function (startPort, endPort) {
        var webSocketUrl = (0, helpers_1.getWebsocketUrl)(index_1.asperaSdk.globals.asperaAppUrl);
        var checkPort = function (port) {
            return new Promise(function (resolve, reject) {
                var webSocket = new WebSocket("".concat(webSocketUrl, ":").concat(port));
                webSocket.onopen = function () {
                    resolve(webSocket);
                };
                webSocket.onerror = function () {
                    reject("Connection failed on port ".concat(port));
                };
            });
        };
        return new Promise(function (resolve, reject) {
            var connectPort = function (port) {
                if (port > endPort) {
                    return reject('No available WebSocket connection found');
                }
                checkPort(port)
                    .then(function (ws) { return resolve(ws); })
                    .catch(function (error) {
                    connectPort(port + 1);
                });
            };
            connectPort(startPort);
        });
    };
    WebsocketService.prototype.notifyEvent = function (event) {
        if (typeof this.eventListener === 'function') {
            this.eventListener(event);
        }
    };
    WebsocketService.prototype.updateRpcPort = function () {
        if (!this.globalSocket) {
            return;
        }
        var url = new URL(this.globalSocket.url);
        index_1.asperaSdk.globals.rpcPort = Number(url.port);
    };
    return WebsocketService;
}());
exports.WebsocketService = WebsocketService;
exports.websocketService = new WebsocketService();
exports.default = WebsocketService;
